// extracted by mini-css-extract-plugin
export default {"uploadBox":"file-manual-upload__uploadBox","dragger":"file-manual-upload__dragger","spacer":"file-manual-upload__spacer","uploadButton":"file-manual-upload__uploadButton"};